import { paths } from '../routes/paths';

// Role keys exactly as the backend returns them in user.roles (architecture/api-contracts.md §1).
export const ROLES = {
  ADMIN: 'admin',
  ORGANISER_OWNER: 'organizer_owner',
  ORGANISER_STAFF: 'organizer_staff',
  ATTENDEE: 'attendee',
};

// Only the owner has the organiser panel. Staff are ordinary users (attendees) who can also switch on staff mode, the
// door check-in screens (Figma "Staff check-in"); the owner can open those too.
export const ORGANISER_ROLES = [ROLES.ORGANISER_OWNER];
export const STAFF_MODE_ROLES = [ROLES.ORGANISER_STAFF];

export const hasAnyRole = (user, roles) => !!user && roles.some((r) => user.roles?.includes(r));

// The plain-English name of the user's role, for menus and profile headers.
export function roleLabelFor(user) {
  if (hasAnyRole(user, [ROLES.ADMIN])) return 'Platform admin';
  if (hasAnyRole(user, [ROLES.ORGANISER_OWNER])) return 'Organiser';
  if (hasAnyRole(user, [ROLES.ORGANISER_STAFF])) return 'Organiser staff';
  return 'Attendee';
}
export const isOrganiserSide = (user) => hasAnyRole(user, ORGANISER_ROLES);
export const canUseStaffMode = (user) => hasAnyRole(user, STAFF_MODE_ROLES);

// One profile page per person: admins and organisers edit theirs inside their panel, attendees on the site.
export function profilePathFor(user) {
  if (hasAnyRole(user, [ROLES.ADMIN])) return paths.admin.profile;
  if (isOrganiserSide(user)) return paths.organiser.profile;
  return paths.attendeeDashboard;
}

// Where a signed-in user "lives": used after login and when they hit a page their role can't see.
// It must always return a path that user is allowed on, so redirects can never loop.
export function homePathFor(user) {
  if (hasAnyRole(user, [ROLES.ADMIN])) return paths.admin.root;
  if (isOrganiserSide(user)) return paths.organiser.dashboard;
  return paths.home;
}
